import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ModalWrapperChildren from "@Elements/Modal/ModalWrapperChildren";
import styles from "@Pages/Event/Event.module.sass";
import { useTranslation } from 'react-i18next';
import { useSelector } from "react-redux";

const ModalPseudonymWarning = ({modalPseudonymWarning, setModalPseudonymWarning, currentPseudonym, signIn}) => {
	const { t } = useTranslation();
	const [isTermsAccepted, setIsTermsAccepted] = useState(false);

	const accountUrl = useSelector(state => state.app.config.accountUrl);

	const regulationsUrl = "https://www.bu.uni.wroc.pl/sites/default/files/regulamin_udzialu_w_wydarzeniach_organizowanych_przez_UWr.pdf";

	return (
		<ModalWrapperChildren
			modalVisible={modalPseudonymWarning}
			setModalVisible={() => setModalPseudonymWarning(false)}
			title={t('events.pseudonymWarning.title')}
			closeButtonName={t('events.pseudonymWarning.cancel')}
			confirmButtonName={t('events.pseudonymWarning.confirm')}
			onConfirm={() => {signIn(), setModalPseudonymWarning(false);}}
			confirmButtonDisabled={!isTermsAccepted}
			withFooter
		>
			<div className={ styles["teams__delete-event"] } style={{ paddingBottom: '3px' }} >
				<span>{t('events.pseudonymWarning.description1')} <strong>{currentPseudonym}</strong> {t('events.pseudonymWarning.description2')} <a href={ accountUrl } target='_blank' rel='noreferrer noopener'>{t('events.pseudonymWarning.description3')}</a> {t('events.pseudonymWarning.description4')}</span>
			</div>

			<div className={ styles["teams__delete-event"] } style={{ paddingTop: '3px' }} >
				<input
					type='checkbox'
					id='terms-checkbox'
					checked={isTermsAccepted}
					onChange={() => setIsTermsAccepted(!isTermsAccepted)}
				/>
				<label htmlFor='terms-checkbox' style={{ fontSize: '1rem' }}>
					{t('events.pseudonymWarning.terms1')}
					<a href={regulationsUrl} target='_blank' rel='noopener noreferrer'>
						{t('events.pseudonymWarning.terms2')}
					</a>
				</label>
			</div>
		</ModalWrapperChildren>
	);
};

ModalPseudonymWarning.propTypes = {
	modalPseudonymWarning: PropTypes.bool,
	setModalPseudonymWarning: PropTypes.func,
	currentPseudonym: PropTypes.string,
	signIn: PropTypes.func,
};

export default ModalPseudonymWarning;